import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Box } from '@material-ui/core'
import { isEmpty } from 'lodash'

import { BaseDialog } from 'components'
import { FragilityFields, StagedFragilitiesTable } from './components'

import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import * as service from 'service'
import theme from 'theme'

import useStyles from './styles'

const FragilityModal = ({
  open,
  setOpen,
  companySupplierId,
  linkedFragilities = [],
  refresh,
}) => {
  const [stagedFragilities, setStagedFragilities] = useState([])
  const [saving, setSaving] = useState(false)

  const classes = useStyles()
  const snackbar = useSnackbar()

  const handleSave = async () => {
    if (isEmpty(stagedFragilities)) return

    const companyFragilityIds = stagedFragilities
      .filter((item) => !item.isNew)
      .map((item) => item.companyFragilityId)
    const companyFragilities = stagedFragilities
      .filter((item) => item.isNew)
      .map((item) => ({ name: item.name }))

    try {
      setSaving(true)

      await service.dponet.suppliers.companyFragilities.create({
        companySupplierId,
        companyFragilityIds,
        companyFragilities,
      })

      refresh()

      snackbar.open({
        message: 'Ameaças vinculadas com sucesso',
        variant: 'success',
      })
      setStagedFragilities([])
      setOpen(false)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao vincular ameaças',
        variant: 'error',
      })
    } finally {
      setSaving(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Adicionar ameaças"
      dialogSize="sm"
      fullWidth
      closeButtonText="Fechar"
      actionButtonText="Salvar"
      actionButton={handleSave}
      disableButton={isEmpty(stagedFragilities)}
      closeIconButton
      loading={saving}
      accentColor={theme.palette.primary.main}
    >
      <Box className={classes.content}>
        <FragilityFields
          linkedFragilities={linkedFragilities}
          stagedFragilities={stagedFragilities}
          setStagedFragilities={setStagedFragilities}
          saving={saving}
        />

        <StagedFragilitiesTable
          stagedFragilities={stagedFragilities}
          setStagedFragilities={setStagedFragilities}
          saving={saving}
        />
      </Box>
    </BaseDialog>
  )
}

FragilityModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  companySupplierId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  linkedFragilities: PropTypes.array,
  refresh: PropTypes.func.isRequired,
}

export default FragilityModal
